<template>
    <div ref="footer" class="btcdirect-widget-footer">
        <div class="powered-by-parent">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.581 2.98552C12.5112 2.92909 12.4297 2.88902 12.3424 2.86824C12.2552 2.84746 12.1643 2.8465 12.0766 2.86544C11.4351 2.99989 10.7728 3.00161 10.1305 2.87047C9.48829 2.73934 8.87968 2.47813 8.34218 2.10293C8.24168 2.03321 8.12227 1.99585 7.99995 1.99585C7.87763 1.99585 7.75823 2.03321 7.65773 2.10293C7.12023 2.47813 6.51162 2.73934 5.86937 2.87047C5.22712 3.00161 4.56482 2.99989 3.92326 2.86544C3.83557 2.8465 3.74474 2.84746 3.65747 2.86824C3.57019 2.88902 3.48868 2.92909 3.41893 2.98552C3.34927 3.04202 3.29316 3.11342 3.25471 3.19446C3.21627 3.27551 3.19648 3.36413 3.19678 3.45383V7.92678C3.19625 8.7876 3.40138 9.63609 3.7951 10.4016C4.18881 11.1671 4.75972 11.8275 5.46028 12.3277L7.65172 13.8887C7.75341 13.9611 7.87513 14 7.99995 14C8.12478 14 8.2465 13.9611 8.34818 13.8887L10.5396 12.3277C11.2402 11.8275 11.8111 11.1671 12.2048 10.4016C12.5985 9.63609 12.8037 8.7876 12.8031 7.92678V3.45383C12.8034 3.36413 12.7836 3.27551 12.7452 3.19446C12.7068 3.11342 12.6506 3.04202 12.581 2.98552ZM11.6023 7.92678C11.6028 8.59608 11.4434 9.2558 11.1374 9.85106C10.8314 10.4463 10.3877 10.9599 9.84317 11.349L7.99995 12.6639L6.15674 11.349C5.6122 10.9599 5.16847 10.4463 4.86249 9.85106C4.55651 9.2558 4.39711 8.59608 4.39757 7.92678V4.14428C5.65626 4.25201 6.91686 3.95997 7.99995 3.30973C9.08305 3.95997 10.3436 4.25201 11.6023 4.14428V7.92678ZM8.92456 6.55187L7.3095 8.17294L6.77514 7.63259C6.66209 7.51953 6.50875 7.45601 6.34886 7.45601C6.18898 7.45601 6.03564 7.51953 5.92258 7.63259C5.80952 7.74564 5.74601 7.89898 5.74601 8.05887C5.74601 8.21875 5.80952 8.37209 5.92258 8.48515L6.88322 9.44578C6.93903 9.50206 7.00544 9.54672 7.0786 9.57721C7.15176 9.60769 7.23024 9.62338 7.3095 9.62338C7.38876 9.62338 7.46723 9.60769 7.5404 9.57721C7.61356 9.54672 7.67996 9.50206 7.73578 9.44578L9.80114 7.39843C9.9142 7.28537 9.97772 7.13204 9.97772 6.97215C9.97772 6.81226 9.9142 6.65893 9.80114 6.54587C9.68809 6.43281 9.53475 6.3693 9.37486 6.3693C9.21498 6.3693 9.06164 6.43281 8.94858 6.54587L8.92456 6.55187Z" fill="#627185"/></svg>

            <div class="powered-by">
                {{ t('widget.footer.powered-by') }}
                <span class="logo">
                    <icon name="logo-alt" alt="BTC Direct logo" />
                </span>
            </div>
        </div>

        <div>
            <a class="support-link" :href="getPublicLink('support')" target="_blank" :title="t('widget.footer.contact-support.link')">
                {{ t('widget.footer.contact-support.link') }}
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.66475 5.53975C3.44508 5.75942 3.44508 6.11558 3.66475 6.33525C3.88442 6.55492 4.24058 6.55492 4.46025 6.33525L8.375 2.4205V3.6875C8.375 3.99816 8.62684 4.25 8.9375 4.25C9.24816 4.25 9.5 3.99816 9.5 3.6875V1.0625C9.5 0.75184 9.24816 0.5 8.9375 0.5H6.3125C6.00184 0.5 5.75 0.75184 5.75 1.0625C5.75 1.37316 6.00184 1.625 6.3125 1.625H7.5795L3.66475 5.53975Z" fill="#627185"/>
                    <path d="M1.625 4.0625C1.625 3.54473 2.04473 3.125 2.5625 3.125H4.25C4.56066 3.125 4.8125 2.87316 4.8125 2.5625C4.8125 2.25184 4.56066 2 4.25 2H2.5625C1.42341 2 0.5 2.92341 0.5 4.0625V7.4375C0.5 8.57659 1.42341 9.5 2.5625 9.5H5.9375C7.07659 9.5 8 8.57659 8 7.4375V5.75C8 5.43934 7.74816 5.1875 7.4375 5.1875C7.12684 5.1875 6.875 5.43934 6.875 5.75V7.4375C6.875 7.95527 6.45527 8.375 5.9375 8.375H2.5625C2.04473 8.375 1.625 7.95527 1.625 7.4375V4.0625Z" fill="#627185"/>
                </svg>
            </a>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useTranslations } from '@btcdirect/composables';
import { useSystemInfo } from '@btcdirect/shared/src/composables/api/system/system-info';
import Icon from '../icons/icon.vue';

/**
 * NOTE: This initiates the call to system-info for each widget.
 * Make sure to add it for each widget when removing this component
 */
const { getPublicLink } = useSystemInfo();

const { t } = useTranslations();
</script>

<style lang="scss" scoped>
@use '@@scss/fonts';
@use '@@scss/variables';

.btcdirect-widget-footer {
    @include fonts.font(variables.$font-size-small, 1.5rem, var(--text-color-subtler));
    border-top: 1px solid var(--ootv-input-border-color);
    padding: 11px variables.$default-padding;
    text-align: center;
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;

    .powered-by-parent {
        display: flex;
        gap: 2px;
        align-items: center;

        > svg {
            flex-shrink: 0;
        }
    }

    .powered-by {
        text-align: left;
        font-weight: 500;
        gap: 2px;
        line-height: 1.5rem;
        display: inline-flex;
        column-gap: 8px;
        align-items: center;
        line-height: 1.25;

        .logo {
            display: inline-flex;
            height: 23px;
        }
    }

    .support-link {
        display: inline-flex;
        padding: 4px 8px;
        border-radius: 9999px;
        border: 1px solid var(--ootv-input-border-color);
        align-items: center;
        gap: 4px;
        color: var(--text-color-subtler) !important;
        line-height: 1.2;
        transition: background-color 0.2s ease-in-out;

        svg {
            flex-shrink: 0;
        }

        &:hover {
            background-color: var(--background-light);
            text-decoration: none;
        }
    }
}
</style>
